import { ICreateModifierState } from './createModifierContext';
import { CreateModifierActionTypes, TCreateModifierAction } from './createModifierActions';

export const createModifierReducer = (
	state: ICreateModifierState,
	action: TCreateModifierAction,
): ICreateModifierState => {
	switch (action.type) {
		case CreateModifierActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateModifierActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case CreateModifierActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case CreateModifierActionTypes.SET_CUSTOMER:
			return {
				...state,
				selectedCustomer: action.payload.customer,
				fetchedRestaurants: [],
				restaurantsForPrice: [],
				totalPrices: [],
				fetchedModifierGroups: [],
				selectedModifierGroups: [],
				isDisabledInRestaurants: [],
				isRestrictedInRestaurants: [],
				isPreselectedInRestaurants: [],
				quantityRegulationRestaurants: [],
				quantityMaxLimit: null,
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
			};
		case CreateModifierActionTypes.SET_FETCHED_MODIFIER_GROUPS:
			return {
				...state,
				fetchedModifierGroups: action.payload.modifierGroups,
			};
		case CreateModifierActionTypes.SET_MODIFIER_GROUPS:
			return {
				...state,
				selectedModifierGroups: action.payload.modifierGroups,
			};
		case CreateModifierActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateModifierActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case CreateModifierActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case CreateModifierActionTypes.SET_RESTAURANTS_FOR_PRICE:
			return {
				...state,
				restaurantsForPrice: action.payload.restaurants,
			};
		case CreateModifierActionTypes.CHANGE_PRICE:
			return {
				...state,
				price: action.payload.price,
			};
		case CreateModifierActionTypes.ADD_PRICE:
			return {
				...state,
				totalPrices: [...state.totalPrices, ...action.payload.prices],
				price: '',
			};
		case CreateModifierActionTypes.REMOVE_PRICE:
			return {
				...state,
				totalPrices: action.payload.updatedTotalPrices,
				restaurantsForPrice: action.payload.updatedRestaurantsForPrices,
				selectedModifierGroups: [],
				isDisabledInRestaurants: action.payload.updatedIsDisabledInRestaurants,
				isRestrictedInRestaurants: action.payload.updatedIsRestrictedInRestaurants,
				isPreselectedInRestaurants: action.payload.updatedIsPreselectedInRestaurants,
				quantityRegulationRestaurants: action.payload.updatedQuantityRegulationRestaurants,
				quantityMaxLimit: !action.payload.updatedQuantityRegulationRestaurants.length
					? null
					: state.quantityMaxLimit,
			};
		case CreateModifierActionTypes.SET_IS_DISABLED_IN_RESTAURANTS:
			return {
				...state,
				isDisabledInRestaurants: action.payload.disabledInRestaurants,
			};
		case CreateModifierActionTypes.SET_IS_RESTRICTED_IN_RESTAURANTS:
			return {
				...state,
				isRestrictedInRestaurants: action.payload.restrictedInRestaurants,
			};
		case CreateModifierActionTypes.SET_IS_PRESELECTED_IN_RESTAURANTS:
			return {
				...state,
				isPreselectedInRestaurants: action.payload.preselectedInRestaurants,
			};
		case CreateModifierActionTypes.SET_QUANTITY_REGULATION_RESTAURANTS:
			return {
				...state,
				quantityRegulationRestaurants: action.payload.quantityRegulationRestaurants,
				quantityMaxLimit: !action.payload.quantityRegulationRestaurants.length ? null : state.quantityMaxLimit,
			};
		case CreateModifierActionTypes.CHANGE_QUANTITY_MAX_LIMIT:
			return {
				...state,
				quantityMaxLimit: action.payload.quantityMaxLimit,
			};
		case CreateModifierActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateModifierActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateModifierActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateModifierActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case CreateModifierActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case CreateModifierActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateModifierActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateModifierActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case CreateModifierActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				fetchedCustomers: [],
				selectedCustomer: null,
				fetchedModifierGroups: [],
				selectedModifierGroups: [],
				name: '',
				description: '',
				fetchedRestaurants: [],
				restaurantsForPrice: [],
				price: '',
				totalPrices: [],
				isDisabledInRestaurants: [],
				isRestrictedInRestaurants: [],
				isPreselectedInRestaurants: [],
				quantityRegulationRestaurants: [],
				quantityMaxLimit: null,
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				activationSchedule: null,
				deactivationSchedule: null,
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
